import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import useGeoLocation from "@/services/useGeoLocation";
import { validateCountryExists } from "@/utils/countryValidation";
import {
  getCookie,
  clearStayGlobal,
  setSelectedCountryByUser,
} from "@/utils/cookieutils";
import { COUNTRY_CODE_TO_URL_MAP } from "@/Config/countryConstants";

interface CountryRedirectProps {
  children: React.ReactNode;
}

const CountryRedirect: React.FC<CountryRedirectProps> = ({ children }) => {
  const router = useRouter();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const geoLocationData = useGeoLocation();

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient || isRedirecting) return;
    if (router.asPath !== "/") return;
    const stayGlobal = getCookie("stayGlobal");
    if (stayGlobal === "true") {
      document.cookie = "SelectedCountryByUser=; path=/; max-age=0";
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const globalParam = urlParams.get("global");
    if (globalParam === "true") {
      document.cookie = "stayGlobal=true; path=/; max-age=31536000";
      return;
    }
    if (geoLocationData && (geoLocationData as any).countryCode) {
      const countryCode = (geoLocationData as any).countryCode;
      const countryUrl = COUNTRY_CODE_TO_URL_MAP[countryCode];
      if (countryUrl && countryUrl !== "south-africa") {
        validateCountryExists(countryUrl)
          .then((exists) => {
            if (exists) {
              setSelectedCountryByUser(countryUrl);
              clearStayGlobal();
              setIsRedirecting(true);
              router.replace(`/${countryUrl}`);
            }
          })
          .catch(() => {});
      }
    }
  }, [isClient, router, isRedirecting, geoLocationData]);

  return <>{children}</>;
};

export default CountryRedirect;
